export default __webpack_public_path__ + "static/media/like-active.2be73703.svg";